/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useContext,
  useReducer,
  useState,
  useEffect,
  useRef,
} from "react";
import { Store } from "../Store";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import axios from "axios";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Radio, RadioGroup, FormControlLabel, Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination } from "swiper/modules";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0.1px solid gainsboro",
  borderRadius: "1rem",
  boxShadow: "1px 2px 1px gainsboro",
  p: 4,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loading: true };
    case "FETCHED":
      return { ...state, dataUser: action.payload, loading: false };
    case "FETCH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const reducer2 = (state, action) => {
  switch (action.type) {
    case "ADD_REQUEST":
      return { ...state, loadingAdd: true };
    case "ADD_SUCCESS":
      return { ...state, loadingAdd: false };
    case "ADD_FAIL":
      return { ...state, loadingAdd: false };
    default:
      return state;
  }
};

const reducer3 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingComments: true };
    case "FETCHED":
      return { ...state, dataComments: action.payload, loadingComments: false };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingComments: false,
        errorComments: action.payload,
      };
    default:
      return state;
  }
};

const reducer4 = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDel: true };
    case "DELETE_SUCCESS":
      return { ...state, loadingDel: false };
    case "DELETE_FAIL":
      return { ...state, loadingDel: false };
    default:
      return state;
  }
};

const reducer5 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingAllContactList: true };
    case "FETCHED":
      return {
        ...state,
        dataAllContactList: action.payload,
        loadingAllContactList: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingAllContactList: false,
        errorAllContactList: action.payload,
      };
    default:
      return state;
  }
};

const edits = ["Update Post", "Delete Post"];
const editsAsAdmin = ["Update Post", "Delete Post"];
const editsAsUser = ["Report Post"];

export default function PostProfile(props) {
  const { onePost: post, switchFilter } = props;
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [anchorElPost, setAnchorElPost] = useState(null);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSignInModalChat, setShowSignInModalChat] = useState(false);

  const [idxImage, setIdxImage] = useState(0);

  const locationMenu = useLocation();

  const navigate = useNavigate();
  const selectedImageRef = useRef(null);
  const [animate, setAnimate] = useState(false);
  const [socialMediaOptions, setSocialMediaOptions] = useState(true);
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const [totalLikes, setTotalLikes] = useState(
    parseInt(post?.total_likes || 0)
  );
  const [likes, setLikes] = useState(
    (post && post.user_liked?.user_liked) || 0
  );
  const [selectedImage, setSelectedImage] = useState(
    post?.images?.[0] || "../images/default_post_2.png"
  );
  const isNull = !!post?.images;
  const imagess = post?.images || [];
 
  const createdDate = new Date(post?.created_at);

  const [{ dataUser }, dispatch] = useReducer(reducer, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ loadingAdd }] = useReducer(reducer2, {
    loadingAdd: false,
  });

  const [, dispatch3] = useReducer(reducer3, {
    dataComments: [],
    loadingComments: true,
    errorComments: "",
  });

  const [{ loadingDel }] = useReducer(reducer4, {
    loadingDel: false,
  });

  const [{ dataAllContactList }, dispatch5] = useReducer(reducer5, {
    dataAllContactList: [],
    loadingAllContactList: true,
    errorAllContactList: "",
  });

  useEffect(async () => {
    if (userInfo !== null) {
      dispatch({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        toast.error(getError(error));
      }
    }
  }, []);

  useEffect(async () => {
    if (!post) {
      return;
    }
    dispatch3({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/getComment?postId=${post.id}`,
        {
          auth: {
            username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
            password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
          },
        }
      );
      dispatch3({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch3({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  }, [loadingAdd, loadingDel]);

  async function unlikePostClick(postId) {
    if (userInfo !== null) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/unlikePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(false);

        // Decrease the total likes count
        setTotalLikes((prevTotalLikes) => Math.max(0, prevTotalLikes - 1));

        toast.success("Unliked successfully!");
      } catch (err) {
        console.log(err);
      }
    }
  }

  async function likePostClick(postId) {
    if (userInfo !== null) {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/likePost`,
          {
            postId: postId,
          },
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );

        // Update the likes state for the specific post
        setLikes(true);

        // Increase the total likes count
        setTotalLikes((prevTotalLikes) => prevTotalLikes + 1);

        toast.success("Like successfully!");
        sendNotification({ notifNum: 2 });
      } catch (err) {}
    }
  }

  const sendNotification = async (payload) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/sendNotif`,
        {
          postId: post.id,
          targetUserId:
            payload.notifNum === 5
              ? [post.user_id, payload.commentOwner]
              : post.user_id,
          notifNumber: payload.notifNum,
          ...(payload.notifNum === 5 && { replyId: payload.replyId }),
          ...(payload.notifNum === 5 && { comment: payload.comment }),
          // detailId: like_id,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
    } catch (error) {}
  };

  function handleButtonClick(postId) {
    if (likes) {
      unlikePostClick(postId);
    } else {
      likePostClick(postId);
    }
    setAnimate(true);
    setTimeout(() => setAnimate(false), 200);
  }

  useEffect(() => {
    if (!post) {
      return;
    }

    setLikes(post.user_liked);
  }, [post]);

  const autoHyperlink = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.split(urlPattern).map((part, index) =>
      urlPattern.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#F95C3D]"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  const ReadMore = ({ children }) => {
    const text = children;
    const [showMore, setShowMore] = useState(true);
    const toggleReadMore = () => {
      setShowMore(!showMore);
    };

    if (text.length <= 100) {
      return (
        <p className="whitespace-pre-wrap break-words">{autoHyperlink(text)}</p>
      );
    } else {
      const sliceLimit = 100;
      const endOfSentence = text.lastIndexOf(" ", sliceLimit);
      const displayText = showMore
        ? text.slice(0, endOfSentence) + "..."
        : text;

      return (
        <p className="whitespace-pre-wrap break-words w-full">
          {autoHyperlink(displayText)}
          <span
            onClick={toggleReadMore}
            className="whitespace-nowrap text-sm text-[#F95C3D] cursor-pointer"
          >
            {showMore ? " read more" : " show less"}
          </span>
        </p>
      );
    }
  };

  const nominal = post && post.price ? post.price : "";
  const price =
    post &&
    post.price &&
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: post.abbreviation ? post.abbreviation : "IDR",
      maximumFractionDigits: 0,
    }).format(nominal);

  const formattedDate = createdDate.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  const date_diff_indays = function (date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(
        dt2.getFullYear(),
        dt2.getMonth(),
        dt2.getDate(),
        dt2.getHours(),
        dt2.getMinutes(),
        dt2.getSeconds()
      ) -
        Date.UTC(
          dt1.getFullYear(),
          dt1.getMonth(),
          dt1.getDate(),
          dt1.getHours(),
          dt1.getMinutes(),
          dt1.getSeconds()
        )) /
        1000
    );
  };

  const UploadDate = ({ timestamp }) => {
    let currentDate = new Date();
    let uploadDate = new Date(timestamp);

    let diffDate = date_diff_indays(uploadDate, currentDate);
    let date = "";
    if (diffDate >= 604800) {
      date = Math.floor(diffDate / 604800) + "w";
      return date;
    } else if (diffDate >= 86400) {
      date = Math.floor(diffDate / 86400) + "d";
      return date;
    } else if (diffDate >= 3600) {
      date = Math.floor(diffDate / 3600) + "h";
      return date;
    } else if (diffDate >= 60) {
      date = Math.floor(diffDate / 60) + "m";
      return date;
    } else {
      if (diffDate < 0) {
        diffDate = 0;
      }
      date = diffDate + "s";
      return date;
    }
  };

  function SetProfilePicture() {
    const isNull = post.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPP />;
    } else {
      return <ProfilePicture />;
    }
  }

  function DefaultPP() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function ProfilePicture() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-12 h-12"
        src={post.picture}
        alt="profilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function SetUsername() {
    if (post.username === null) {
      return (
        <p className="leading-tight">
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-4 h-4"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            {formattedDate}
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </p>
      );
    } else {
      return (
        <p className="leading-tight">
          {/* {post.username} */}
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-4 h-4"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-sm text-gray-500 leading-tight">
            {formattedDate}
          </div>
          <div className="text-s text-gray-500 leading-tight">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </p>
      );
    }
  }

  function SetDefaultImage() {
    if (isNull === "null" || isNull === null) {
      return (
        <div className="relative bg-[#F5F5F5] rounded-md w-[98%] h-[98%] lg:w-[37rem]">
          <img
            className="w-[55rem] h-[30rem] rounded-lg shadow-none items-center  justify-center "
            src="../images/default_post_2.png"
            alt="postImage"
          />

          <div className="absolute top-0 right-0 px-6 py-4">
            <div className="mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={() => handleButtonClick(post.id)} title="Like">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`hover:opacity-100 ${
                    likes ? "opacity-100 " : "opacity-50"
                  }`}
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    stroke="#e0e0e0"
                    strokeWidth="2"
                  />
                  <path
                    d="M18.7964 6.82289C19.2124 5.7257 20.7866 5.7257 21.2039 6.82289L23.8948 14.277C23.9887 14.5198 24.154 14.7284 24.3689 14.8754C24.5838 15.0223 24.8382 15.1005 25.0985 15.0999H31.7113C32.9333 15.0999 33.4663 16.6208 32.5056 17.3657L27.7998 21.5998C27.589 21.7618 27.435 21.9865 27.3598 22.2415C27.2846 22.4965 27.2921 22.7688 27.3812 23.0193L29.0998 30.3031C29.5183 31.4731 28.1638 32.478 27.1394 31.7578L20.7476 27.7019C20.5287 27.548 20.2677 27.4655 20.0002 27.4655C19.7326 27.4655 19.4716 27.548 19.2527 27.7019L12.8609 31.7578C11.8378 32.478 10.482 31.4718 10.9006 30.3031L12.6191 23.0193C12.7082 22.7688 12.7157 22.4965 12.6405 22.2415C12.5653 21.9865 12.4113 21.7618 12.2005 21.5998L7.49471 17.3657C6.53276 16.6208 7.06833 15.0999 8.28768 15.0999H14.9005C15.1609 15.1007 15.4153 15.0225 15.6303 14.8756C15.8452 14.7286 16.0105 14.5199 16.1042 14.277L18.7964 6.82289Z"
                    stroke={likes ? "none" : "black"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={likes ? "#FFDD43" : "none"}
                  />
                </svg>
              </Tooltip>
            </div>

            <div className="hidden lg:flex mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={handleButtonModalDetailComment} title="Comment">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M20.4751 15.5679V23.4846M16.5168 19.5262H24.4334M20.4751 31.3999C22.8237 31.3999 25.1197 30.7034 27.0725 29.3986C29.0253 28.0938 30.5474 26.2391 31.4462 24.0693C32.345 21.8994 32.5801 19.5117 32.1219 17.2082C31.6637 14.9047 30.5327 12.7888 28.872 11.128C27.2112 9.46727 25.0953 8.33628 22.7918 7.87808C20.4883 7.41988 18.1006 7.65505 15.9307 8.55384C13.7609 9.45263 11.9062 10.9747 10.6014 12.9275C9.29655 14.8803 8.6001 17.1763 8.6001 19.5249C8.6001 21.4882 9.0751 23.3394 9.91954 24.9703L8.6001 31.3999L15.0297 30.0805C16.6606 30.9249 18.5131 31.3999 20.4751 31.3999Z"
                    stroke="black"
                    strokeOpacity="1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Tooltip>
            </div>
            <div className="flex lg:hidden mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip onClick={handleButtonModalDetailComment} title="Comment">
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M20.4751 15.5679V23.4846M16.5168 19.5262H24.4334M20.4751 31.3999C22.8237 31.3999 25.1197 30.7034 27.0725 29.3986C29.0253 28.0938 30.5474 26.2391 31.4462 24.0693C32.345 21.8994 32.5801 19.5117 32.1219 17.2082C31.6637 14.9047 30.5327 12.7888 28.872 11.128C27.2112 9.46727 25.0953 8.33628 22.7918 7.87808C20.4883 7.41988 18.1006 7.65505 15.9307 8.55384C13.7609 9.45263 11.9062 10.9747 10.6014 12.9275C9.29655 14.8803 8.6001 17.1763 8.6001 19.5249C8.6001 21.4882 9.0751 23.3394 9.91954 24.9703L8.6001 31.3999L15.0297 30.0805C16.6606 30.9249 18.5131 31.3999 20.4751 31.3999Z"
                    stroke="black"
                    strokeOpacity="1"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Tooltip>
            </div>

            <div className="mb-3 text-xl font-semibold tracking-tight cursor-pointer">
              <Tooltip
                // onClick={handleCopyLink}
                title="Share Post"
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="opacity-50 hover:opacity-100"
                >
                  <circle
                    cx="20"
                    cy="20"
                    r="19"
                    fill="white"
                    fillOpacity="1"
                    stroke="#D1D1D1"
                    strokeWidth="2"
                  />
                  <path
                    d="M21.863 9.63768C22.0168 9.56647 22.1886 9.53764 22.3588 9.55448C22.5291 9.57132 22.6909 9.63315 22.8258 9.73293L31.0468 15.7937C31.1528 15.8718 31.2393 15.971 31.3003 16.0843C31.3612 16.1976 31.3951 16.3223 31.3994 16.4494C31.4038 16.5765 31.3785 16.703 31.3255 16.8199C31.2724 16.9367 31.1929 17.041 31.0925 17.1254L22.8715 24.052C22.7398 24.1629 22.5772 24.2353 22.4031 24.2605C22.2291 24.2857 22.051 24.2628 21.8905 24.1943C21.7299 24.1259 21.5935 24.015 21.4979 23.8748C21.4023 23.7347 21.3515 23.5713 21.3515 23.4044V20.0381C20.9204 20.1073 20.3577 20.2285 19.7 20.4363C18.1052 20.942 15.9476 21.9585 13.7773 24.0174C13.6445 24.1438 13.4738 24.2282 13.2884 24.2591C13.1031 24.29 12.9123 24.2659 12.7419 24.1901C12.5716 24.1143 12.4302 23.9905 12.3369 23.8356C12.2436 23.6807 12.203 23.5023 12.2208 23.3247C12.482 20.6043 13.3187 18.6198 14.4569 17.1895C15.4337 15.9549 16.7613 15.0095 18.2842 14.4638C19.2664 14.1109 20.302 13.9098 21.3515 13.8681V10.4169C21.3512 10.2547 21.399 10.0956 21.4894 9.95778C21.5798 9.82 21.7093 9.70909 21.863 9.63768ZM7.6499 15.6119C7.6499 14.4638 8.13109 13.3626 8.98761 12.5507C9.84412 11.7389 11.0058 11.2828 12.2171 11.2828H15.8709C16.1131 11.2828 16.3455 11.374 16.5168 11.5364C16.6881 11.6987 16.7843 11.919 16.7843 12.1486C16.7843 12.3782 16.6881 12.5985 16.5168 12.7608C16.3455 12.9232 16.1131 13.0144 15.8709 13.0144H12.2171C11.4903 13.0144 10.7933 13.2881 10.2794 13.7752C9.7655 14.2623 9.47678 14.923 9.47678 15.6119L9.47678 26.0019C9.47678 26.6908 9.7655 27.3515 10.2794 27.8386C10.7933 28.3257 11.4903 28.5994 12.2171 28.5994H23.1784C23.9052 28.5994 24.6022 28.3257 25.1161 27.8386C25.63 27.3515 25.9187 26.6908 25.9187 26.0019V24.2702C25.9187 24.0406 26.015 23.8204 26.1863 23.658C26.3576 23.4956 26.5899 23.4044 26.8322 23.4044C27.0744 23.4044 27.3068 23.4956 27.4781 23.658C27.6494 23.8204 27.7456 24.0406 27.7456 24.2702V26.0019C27.7456 27.1501 27.2644 28.2512 26.4079 29.0631C25.5514 29.8749 24.3897 30.3311 23.1784 30.3311H12.2171C11.0058 30.3311 9.84412 29.8749 8.98761 29.0631C8.13109 28.2512 7.6499 27.1501 7.6499 26.0019L7.6499 15.6119Z"
                    fill="black"
                    fillOpacity="1"
                  />
                </svg>
              </Tooltip>
            </div>
          </div>
        </div>
      );
    } else {
      const isVideo = selectedImage.includes("smpost-v-");

      return (
        <>
          <div className="flex w-full justify-center lg:w-full">
            <div className="flex">
              <div className="flex-col w-full">
                <div
                  className="w-full h-[75vh] relative bg-[#ffffff] rounded-2xl"
                  style={{
                    border: "0.1px solid gainsboro",
                  }}
                >
                  {isVideo ? (
                    <video
                      className="w-full h-full object-contain rounded-2xl shadow-none"
                      controls
                      autoPlay
                      loop
                      preload="auto"
                      muted
                      src={selectedImage}
                    >
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      className="w-full h-full object-contain rounded-2xl shadow-none"
                      src={selectedImage}
                      alt="postImage"
                    />
                  )}

                  {imagess.length > 1 && (
                    <div className="absolute top-0 left-0 right-0 bottom-0">
                      <button
                        className="hidden lg:flex rounded-lg bg-white mr-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute opacity-0 hover:opacity-100 transition-opacity"
                        style={{
                          top: "50%",
                          left: "2%",
                          transform: "translate(0%, -50%)",
                        }}
                        onClick={handlePreviousClick}
                      >
                        <ArrowBackIosNewIcon />
                      </button>
                      <button
                        className="hidden lg:flex rounded-lg bg-white ml-2 py-1 px-1 shadow-md hover:bg-[#F5F5F5] absolute opacity-0 hover:opacity-100 transition-opacity"
                        style={{
                          top: "50%",
                          right: "2%",
                          transform: "translate(0%, -50%)",
                        }}
                        onClick={handleNextClick}
                      >
                        <ArrowForwardIosIcon />
                      </button>
                    </div>
                  )}
                </div>

                {/* icons desktop */}
                <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end">
                  <div className="flex card-icons items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                            animate ? "scale-150" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleButtonModalDetailComment}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip title="Share Post" className="cursor-pointer">
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674..."
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  const handleOpenUserMenu = (event) => {
    setAnchorElPost(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElPost(null);
  };

  const handleButtonReport = () => {
    setShowReportModal(true);
  };

  const handleCancelReport = () => {
    setShowReportModal(false);
    setSelectedReason("");
  };

  async function handleReportPost(postId, reasonId) {
    // Add your report post logic here
 
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/reportPost`,
        {
          postId: postId,
          reasonId: reasonId,
        },
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post Reported.");
    } catch (error) {
      toast.error(getError(error));
    }

    setShowReportModal(false);
  }

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const modalReportStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: "8px",
  };

  function handleOpenUpdate() {
    setAnchorElPost(null);
    setShowModalUpdate(true);
  }

  function handleCloseModalUpdate() {
    setShowModalUpdate(false);
  }

  const handleCancelButtonModalUpdate = () => {
    setShowModalUpdate(false);
  };

  function handleOpenDelete() {
    setAnchorElPost(null);
    setShowModalDelete(true);
  }

  function handleCloseModalDelete() {
    setShowModalDelete(false);
  }

  const handleCancelButtonModalDelete = () => {
    setShowModalDelete(false);
  };

  function handleButtonModalUpdate() {
    navigate("/update_post", { state: { post } });
  }

  function handleOpenPersonalChat() {
    navigate("/all_chat", { state: { post } });
  }

  function handleCloseSignInModalChat() {
    setShowSignInModalChat(false);
  }

  const handleCancelButtonModalChat = () => {
    setShowSignInModalChat(false);
  };

  function handleSignInButtonModalChat() {
    setShowSignInModalChat(false);
    navigate("/signin");
  }

  const handleButtonModalDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deletePost/${post.id}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post deleted successfully!");
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  useEffect(async () => {
    dispatch5({
      type: "FETCHING",
    });

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllContactList`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );

      const socialMediaOptions = data.data.map((item) => ({
        value: item.id.toString(),
        label: item.name,
        image: item.image,
        url: item.url,
      }));

      dispatch5({
        type: "FETCHED",
        payload: data.data,
      });

      setSocialMediaOptions(socialMediaOptions);
    } catch (error) {
      dispatch5({
        type: "FETCH_FAILED",
        payload: error.message,
      });
    }

    return () => {};
  }, []);

  const openContact = (urlSocialMedia, usernameSocialMedia) => {
    if (dataAllContactList !== null) {
      if (urlSocialMedia) {
        let contactId = Object.keys(post.contact).find(
          (key) => post.contact[key].id === usernameSocialMedia.id
        );
        if (contactId !== undefined) {
          let url = dataAllContactList.find(
            (item) => item.id === contactId
          )?.url;

          // Check if the usernameSocialMedia.value starts with "http://" or "https://"
          if (
            usernameSocialMedia &&
            (usernameSocialMedia.value.startsWith("http://") ||
              usernameSocialMedia.value.startsWith("https://"))
          ) {
            url = usernameSocialMedia.value;
          } else {
            // If not, append it to the URL from dataAllContactList
            if (url === null) {
              url = "tel:" + getPhoneNumber(usernameSocialMedia.value);
            } else if (
              !url.startsWith("http://") &&
              !url.startsWith("https://")
            ) {
              url = "https://" + url;
            }
            url += usernameSocialMedia.value;
          }

          window.open(url);
        } else {
          alert("Contact not found!");
        }
      }
    }
  };

  const getPhoneNumber = () => {
    return "";
  };

  function handleButtonModalDetailInSearch() {
    switchFilter();
    navigate("/detail_post", { state: { post } });
    window.location.reload();
  }

  function handleButtonModalDetailInPost() {
    navigate("/detail_post", { state: { post } });
    window.location.reload();
  }

  function nl2br(text) {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index !== text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  }

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handlePreviousClick = () => {
    const currentIndex = imagess.findIndex((image) => image === selectedImage);
    if (currentIndex > 0) {
      setSelectedImage(imagess[currentIndex - 1]);
    } else {
      setSelectedImage(imagess[imagess.length - 1]);
    }
  };

  const handleNextClick = () => {
    const currentIndex = imagess.findIndex((image) => image === selectedImage);
    if (currentIndex < imagess.length - 1) {
      setSelectedImage(imagess[currentIndex + 1]);
    } else {
      setSelectedImage(imagess[0]);
    }
  };

  function handleUsername(e) {
    navigate(`/${post.username}`, { state: { e } });
  }

  const typeNames = {
    1: "Product",
    2: "Service",
    3: "Event",
    4: "Job",
    5: "Insight",
    6: "Education",
  };

  const getTypeName = (postType, sdType) => {
    // if (postType === 5 && sdType.value === 1) {
    //   return "Review"; // Adjust as needed if sdType.value should dynamically change the type
    // } else if (postType === 5 && sdType.value === 2) {
    //   return "Question"; // Adjust as needed for sdType.value === 2
    // } else {
    return typeNames[postType] || "Unknown Type";
    // }
  };

  function handleButtonModalDetail() {
    navigate("/detail_post", { state: { post } });
  }

  function handleButtonModalDetailComment() {
    navigate(`/detail_post`, { state: { post, scrollToComments: true } });
  }

  return (
    <>
      {/* desktop */}
      {post && (
        <div key={post.id} className="w-full hidden lg:flex p-3">
          <div className="w-3/5 mr-3">
            {post.images && post.images.length > 0 ? (
              <SetDefaultImage />
            ) : (
              <></>
            )}
          </div>

          <div className="w-2/5 card-detail items-center justify-center">
            <div className="flex" style={{ justifyContent: "space-between" }}>
              <div className="profilePost flex w-full">
                <div
                  className="mr-8"
                  style={{ width: "4.0em", marginRight: "2%" }}
                >
                  <SetProfilePicture />
                </div>
                <div
                  className="flex items-center"
                  style={{ justifyContent: "center" }}
                >
                  {userInfo !== null ? (
                    <>
                      {dataUser.user_id === post.user_id ? (
                        <a href={`/${dataUser.username}`}>
                          <SetUsername />
                        </a>
                      ) : (
                        <div
                          onClick={() => handleUsername(post)}
                          style={{ cursor: "pointer" }}
                        >
                          <SetUsername />
                        </div>
                      )}
                    </>
                  ) : (
                    <SetUsername />
                  )}
                </div>
              </div>
              {dataUser.user_id === post.user_id && userInfo !== null ? (
                <div className="flex items-center">
                  <Tooltip title="Edit Post">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                    PaperProps={{
                      sx: {
                        borderRadius: "0.5rem",
                      },
                    }}
                  >
                    {edits.map((edit) => (
                      <MenuItem key={edit}>
                        {edit === "Update Post" ? (
                          <button onClick={handleOpenUpdate}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        ) : (
                          <button onClick={handleOpenDelete}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        )}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
              {dataUser.is_admin === true &&
              dataUser.user_id !== post.user_id &&
              userInfo !== null ? (
                <div className="flex items-center">
                  <Tooltip title="Delete Post">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                  >
                    {editsAsAdmin.map((editAsAdmin) => (
                      <MenuItem key={editAsAdmin}>
                        {editAsAdmin === "Update Post" ? (
                          <button onClick={handleOpenUpdate}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {editAsAdmin}
                            </Typography>{" "}
                          </button>
                        ) : (
                          <button onClick={handleOpenDelete}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {editAsAdmin}
                            </Typography>{" "}
                          </button>
                        )}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
              {dataUser.user_id !== post.user_id &&
              dataUser.is_admin !== true &&
              userInfo !== null ? (
                <div className="flex items-center">
                  <Tooltip title="More">
                    <MoreVertSharpIcon
                      onClick={handleOpenUserMenu}
                      style={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                  <Menu
                    sx={{ mt: "0px" }} // Adjust this value if needed
                    id="menu-appbar"
                    anchorEl={anchorElPost}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    open={Boolean(anchorElPost)}
                    onClose={handleCloseUserMenu}
                    PaperProps={{
                      sx: {
                        borderRadius: "0.5rem",
                      },
                    }}
                  >
                    {editsAsUser.map((edit) => (
                      <MenuItem key={edit}>
                        <button onClick={() => handleButtonReport(post.id)}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="text-2xl">{post.posttitle}</div>

            <div className="flex flex-row items-center mt-3 font-semibold text-lg">
              <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                {post.sd_post_type === 1
                  ? "Share"
                  : post.sd_post_type === 2
                  ? "Seek"
                  : "Unknown"}
              </div>

              <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
                {getTypeName(post.post_type, post.sd_post_type)}
              </div>

              <div className="flex text-[#F95C3D] rounded-lg p-1 max-w-max mb-2">
                {post.category.label}
              </div>
            </div>

            <div className="flex justify-between">
              <div>
                {nominal ? (
                  <div className="my-3 text-2xl font-semibold">{price}</div>
                ) : null}
              </div>
            </div>

            <div className="font-medium overflow-y-auto h-96">
              <ReadMore>{post.description}</ReadMore>
            </div>

            {post.tag && Object.keys(post.tag).length > 0 ? (
              <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
                {Object.keys(post.tag).map((key) => (
                  <div
                    className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                    key={key}
                  >
                    {post.tag[key]}
                  </div>
                ))}
              </div>
            ) : null}

            {post.images && post.images.length > 0 ? (
              <></>
            ) : (
              // icons desktop
              <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
                <div className="flex px-2 items-center">
                  <div className="flex">
                    <Tooltip
                      onClick={() => handleButtonClick(post.id)}
                      title="Like"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                          animate ? "scale-150" : ""
                        }`}
                        viewBox="0 0 20 20"
                        fill={likes ? "#FFDD43" : "currentColor"}
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </Tooltip>

                    <p className="ml-2">{totalLikes}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      onClick={handleButtonModalDetailComment}
                      title="Comment"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Tooltip>
                    <p className="ml-2">{post.total_comments}</p>
                  </div>
                  <div className="flex ml-4">
                    <Tooltip
                      // onClick={handleCopyLink}
                      title="Share Post"
                      className="cursor-pointer"
                    >
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                          fill="currentColor"
                        />
                      </svg>
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end items-center my-5">
              {post.contact && Object.keys(post.contact).length > 0 ? (
                <>
                  <div className="flex items-center">
                    {/* Social Media:{" "} */}
                    <div className="overflow-x-auto flex flex-nowrap items-center">
                      {post.contact &&
                        Object.keys(post.contact).map((contactId) => {
                          const contact = dataAllContactList.find(
                            (item) =>
                              item.id === post.contact[contactId].listcontact_id
                          );
                          return contact ? (
                            <button
                              key={contact.id}
                              onClick={() => openContact(contact.id)}
                              className="inline-flex items-center"
                            >
                              <img
                                src={
                                  Array.isArray(socialMediaOptions) &&
                                  socialMediaOptions.find(
                                    (option) => option.label === contact.name
                                  )?.image
                                }
                                alt={contact.name}
                                className="lineButton ml-1"
                              />
                            </button>
                          ) : null;
                        })}
                    </div>
                    {post.user_id !== dataUser.user_id && (
                      <div className="divider"></div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}{" "}
              {post.user_id !== dataUser.user_id && (
                <>
                  <Tooltip title="Message">
                    <button onClick={handleOpenPersonalChat} className="p-2">
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                          fill="black"
                        />
                        <path
                          d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                          fill="black"
                        />
                      </svg>
                    </button>
                  </Tooltip>
                </>
              )}
            </div>
            <div className="flex text-[#C0BFBF] mt-4 justify-end">
              <div
                onClick={handleButtonModalDetail}
                className="text-[#F95C3D] cursor-pointer flex mb-2"
              >
                See details
                <div className="flex items-center ml-2">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                      fill="#F95C3D"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* mobile */}
      {post && (
        <div key={post.id} className="w-full lg:hidden p-3">
          {/* SetDefaultImage at the top */}
          <div className="w-full items-center justify-center">
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              className="mySwiper rounded-2xl"
            >
              {imagess.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="flex justify-center">
                    <div
                      className="w-[400px] h-[400px] relative bg-[#ffffff] rounded-2xl"
                      style={{
                        border: "0.1px solid gainsboro",
                      }}
                    >
                      <img
                        className="w-full h-full object-contain rounded-2xl shadow-none"
                        src={image}
                        alt="postImage"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            {/* <SetDefaultImage /> */}
            <div className="flex justify-end">
              {/* <div className="flex cursor-pointer overflow-x-auto w-full justify-center mt-4">
                {imagess.map((image, index) => (
                  <>
                    {selectedImage === image ? (
                      <img
                        key={index}
                        className="rounded-2xl shadow-none items-center w-28 h-28 justify-center mx-2 mb-2 flex flex-col border-4 border-[#F95C3D]"
                        src={image}
                        alt={`postImage${index}`}
                        onClick={() => handleImageClick(image)}
                      />
                    ) : (
                      <img
                        key={index}
                        className="rounded-2xl shadow-none items-center w-28 h-28 justify-center mx-2 mb-2 flex flex-col"
                        style={{
                          border: "0.1px solid gainsboro",
                        }}
                        src={image}
                        alt={`postImage${index}`}
                        onClick={() => handleImageClick(image)}
                      />
                    )}
                  </>
                ))}
              </div> */}
              {post.images && post.images.length > 0 ? (
                // icons mobile
                <div className="flex lg:hidden text-[#C0BFBF] my-4 justify-end ">
                  <div className="flex card-icons items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                            animate ? "scale-150" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>

                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleButtonModalDetailComment}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        // onClick={handleCopyLink}
                        title="Share Post"
                        className="cursor-pointer"
                      >
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="w-full items-center justify-center">
            {/* Profile Picture and User Info */}

            <div className="card-detail">
              <div className="flex" style={{ justifyContent: "space-between" }}>
                <div className="profilePost flex w-full">
                  <div
                    className="flex-none mr-8"
                    style={{ width: "4.0em", marginRight: "2%" }}
                  >
                    <SetProfilePicture />
                  </div>
                  <div
                    className="flex items-center"
                    style={{ justifyContent: "center" }}
                  >
                    {userInfo !== null ? (
                      <>
                        {dataUser.user_id === post.user_id ? (
                          <a href={`/${dataUser.username}`}>
                            <SetUsername />
                          </a>
                        ) : (
                          <div
                            onClick={() => handleUsername(post)}
                            style={{ cursor: "pointer" }}
                          >
                            <SetUsername />
                          </div>
                        )}
                      </>
                    ) : (
                      <SetUsername />
                    )}
                  </div>
                </div>

                {dataUser.user_id === post.user_id ? (
                  <div className="flex items-center">
                    <Tooltip title="Edit Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {edits.map((edit) => (
                        <MenuItem key={edit}>
                          {edit === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {edit}
                              </Typography>{" "}
                            </button>
                          )}
                          {/* <Modal
                          open={showModalUpdate}
                          onClose={handleCloseModalUpdate}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box className="modal-notification-style">
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                              style={{
                                marginBottom: "10%",
                                marginTop: "5%",
                                textAlign: "center",
                              }}
                            >
                              Are you sure want to update this post?
                            </Typography>
                            <div className="flex justify-center">
                              <button
                                type="button"
                                className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                                onClick={handleButtonModalUpdate}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                                onClick={handleCancelButtonModalUpdate}
                              >
                                Cancel
                              </button>
                            </div>
                          </Box>
                        </Modal> */}
                          {/* <Modal
                          open={showModalDelete}
                          onClose={handleCloseModalDelete}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                        >
                          <Box className="modal-notification-style">
                            <Typography
                              id="modal-modal-title"
                              variant="h6"
                              component="h2"
                              style={{
                                marginBottom: "10%",
                                marginTop: "5%",
                                textAlign: "center",
                              }}
                            >
                              Are you sure want to delete this post?
                            </Typography>
                            <div className="flex justify-center">
                              <button
                                type="button"
                                className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                                onClick={handleButtonModalDelete}
                              >
                                Delete
                              </button>
                              <button
                                type="button"
                                className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
                                onClick={handleCancelButtonModalDelete}
                              >
                                Cancel
                              </button>
                            </div>
                          </Box>
                        </Modal> */}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.is_admin === true &&
                dataUser.user_id !== post.user_id &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="Delete Post">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                    >
                      {editsAsAdmin.map((editAsAdmin) => (
                        <MenuItem key={editAsAdmin}>
                          {editAsAdmin === "Update Post" ? (
                            <button onClick={handleOpenUpdate}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          ) : (
                            <button onClick={handleOpenDelete}>
                              <Typography
                                textAlign="center"
                                className="no-underline text-black"
                              >
                                {editAsAdmin}
                              </Typography>{" "}
                            </button>
                          )}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
                {dataUser.user_id !== post.user_id &&
                dataUser.is_admin !== true &&
                userInfo !== null ? (
                  <div className="flex items-center">
                    <Tooltip title="More">
                      <MoreVertSharpIcon
                        onClick={handleOpenUserMenu}
                        style={{ cursor: "pointer" }}
                      />
                    </Tooltip>
                    <Menu
                      sx={{ mt: "0px" }} // Adjust this value if needed
                      id="menu-appbar"
                      anchorEl={anchorElPost}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                      open={Boolean(anchorElPost)}
                      onClose={handleCloseUserMenu}
                      PaperProps={{
                        sx: {
                          borderRadius: "0.5rem",
                        },
                      }}
                    >
                      {editsAsUser.map((edit) => (
                        <MenuItem key={edit}>
                          <button onClick={() => handleButtonReport(post.id)}>
                            <Typography
                              textAlign="center"
                              className="no-underline text-black"
                            >
                              {edit}
                            </Typography>{" "}
                          </button>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="text-2xl font-medium">{post.posttitle}</div>

              <div className="flex flex-wrap md:flex-nowrap items-center mt-3 font-semibold">
                <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0">
                  {post.sd_post_type === 1
                    ? "Share"
                    : post.sd_post_type === 2
                    ? "Seek"
                    : "Unknown"}
                </div>

                <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0 md:ml-2">
                  {getTypeName(post.post_type, post.sd_post_type)}
                </div>

                <div className="text-[#F95C3D] p-1 max-w-max mb-2 md:mb-0 md:ml-2">
                  {post.category.label}
                </div>
              </div>

              {nominal ? (
                <div className="my-3 text-2xl font-semibold">{price}</div>
              ) : null}
              <div className="whitespace-pre-wrap">
                <ReadMore>{post.description}</ReadMore>
              </div>

              {post.tag && Object.keys(post.tag).length > 0 ? (
                <div className="flex rounded-lg mt-3 py-2 overflow-x-auto">
                  {Object.keys(post.tag).map((key) => (
                    <div
                      className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                      key={key}
                    >
                      {post.tag[key]}
                    </div>
                  ))}
                </div>
              ) : null}

              {post.images && post.images.length > 0 ? (
                <></>
              ) : (
                // icons mobile
                <div className="flex lg:hidden text-[#C0BFBF] my-4 justify-end ">
                  <div className="flex px-2 items-center">
                    <div className="flex">
                      <Tooltip
                        onClick={() => handleButtonClick(post.id)}
                        title="Like"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                            animate ? "scale-150" : ""
                          }`}
                          viewBox="0 0 20 20"
                          fill={likes ? "#FFDD43" : "currentColor"}
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </Tooltip>

                      <p className="ml-2">{totalLikes}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        onClick={handleButtonModalDetailComment}
                        title="Comment"
                        className="cursor-pointer"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </Tooltip>
                      <p className="ml-2">{post.total_comments}</p>
                    </div>
                    <div className="flex ml-4">
                      <Tooltip
                        // onClick={handleCopyLink}
                        title="Share Post"
                        className="cursor-pointer"
                      >
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 22 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                            fill="currentColor"
                          />
                        </svg>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-end items-center my-5">
                {post.contact && Object.keys(post.contact).length > 0 ? (
                  <>
                    <div className="flex items-center">
                      {/* Social Media:{" "} */}
                      <div className="overflow-x-auto flex flex-nowrap items-center">
                        {post.contact &&
                          Object.keys(post.contact).map((contactId) => {
                            const contact = dataAllContactList.find(
                              (item) =>
                                item.id ===
                                post.contact[contactId].listcontact_id
                            );
                            return contact ? (
                              <button
                                key={contact.id}
                                onClick={() => openContact(contact.id)}
                              >
                                <img
                                  src={
                                    Array.isArray(socialMediaOptions) &&
                                    socialMediaOptions.find(
                                      (option) => option.label === contact.name
                                    )?.image
                                  }
                                  alt={contact.name}
                                  className="lineButton ml-1"
                                />
                              </button>
                            ) : null;
                          })}
                      </div>
                      {post.user_id !== dataUser.user_id && (
                        <div className="divider"></div>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}{" "}
                {post.user_id === dataUser.user_id ? (
                  ""
                ) : (
                  <>
                    <Tooltip title="Message">
                      <button onClick={handleOpenPersonalChat} className="p-2">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                            fill="black"
                          />
                          <path
                            d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                    </Tooltip>
                  </>
                )}
              </div>
              <div className="flex text-[#C0BFBF] mt-4 justify-end">
                <div
                  onClick={handleButtonModalDetail}
                  className="text-[#F95C3D] cursor-pointer flex mb-2"
                >
                  See details
                  <div className="flex items-center ml-2">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                        fill="#F95C3D"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        open={showSignInModalChat}
        onClose={handleCloseSignInModalChat}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ zIndex: 1600 }}
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Sign in to use Direct Page
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleSignInButtonModalChat}
            >
              Sign in
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalChat}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Update */}
      <Modal
        open={showModalUpdate}
        onClose={handleCloseModalUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to update this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalUpdate}
            >
              Update
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalUpdate}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Delete */}
      <Modal
        open={showModalDelete}
        onClose={handleCloseModalDelete}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Are you sure want to delete this post?
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleButtonModalDelete}
            >
              Delete
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalDelete}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      {/* Modal Confirmation Report */}
      <Modal
        open={showReportModal}
        onClose={handleCancelReport}
        aria-labelledby="report-post-title"
        aria-describedby="report-post-description"
      >
        <Box sx={modalReportStyle}>
          <Typography id="report-post-title" variant="h6" component="h2">
            Reason to report post
          </Typography>
          <RadioGroup
            aria-labelledby="report-post-reasons"
            name="report-reasons"
            value={selectedReason}
            onChange={handleReasonChange}
            sx={{ mt: 2 }}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Inappropriate"
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Scam Posts"
            />
            <FormControlLabel value="3" control={<Radio />} label="Spam" />
            <FormControlLabel
              value="4"
              control={<Radio />}
              label="Hate Speech"
            />
            <FormControlLabel value="5" control={<Radio />} label="Violence" />
            <FormControlLabel value="6" control={<Radio />} label="Other" />
          </RadioGroup>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button onClick={handleCancelReport} sx={{ mr: 2 }}>
              Cancel Report
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleReportPost(post.id, selectedReason)}
              disabled={!selectedReason}
            >
              Report Post
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
